import React from 'react';
import cx from 'classnames';

import styles from './styles.module.css';

export type TitleTone = 'neutral' | 'highlight';

export interface TitleSegment {
  text: React.ReactNode;
  tone?: TitleTone;
}

export interface TitleProps {
  segments?: TitleSegment[];
  children?: React.ReactNode;
  as?: keyof React.JSX.IntrinsicElements;
  className?: string;
  ['data-testid']?: string;
}

export const Title: React.FC<TitleProps> = ({
  as: Tag = 'div',
  children,
  className,
  segments,
  'data-testid': dataTestId,
}) => {
  if (segments && segments.length > 0) {
    return (
      <Tag className={cx(styles.title, className)} data-testid={dataTestId}>
        {segments.map((segment, idx) => {
          const tone = segment.tone ?? 'neutral';

          return (
            <span key={idx} className={styles[tone]}>
              {segment.text}
              {idx < segments.length - 1 ? ' ' : ''}
            </span>
          );
        })}
      </Tag>
    );
  }

  return (
    <Tag data-testid={dataTestId} className={cx(styles.title, className)}>
      {children}
    </Tag>
  );
};
